import { createAction } from 'typesafe-actions';

export enum LOGIN_CHECK {
  FETCH_LOGIN_CHECK = 'loginCheck/FETCH_LOGIN_CHECK',
  FETCH_LOGIN_CHECK_SUCCESS = 'loginCheck/FETCH_LOGIN_CHECK_SUCCESS',
  FETCH_LOGIN_CHECK_FAILURE = 'loginCheck/FETCH_LOGIN_CHECK_FAILURE',
}

export const fetchLoginCheck = createAction(LOGIN_CHECK.FETCH_LOGIN_CHECK)();
